module.exports = __webpack_public_path__ + "static/media/contact_info.10557eba.svg";